// extracted by mini-css-extract-plugin
export var breadcrumb = "_0-0";
export var breadcrumbArrow = "_0-1";